export function SlaPage() {
  return (
    <div className="space-y-6 max-w-4xl">
      <div>
        <h1 className="text-2xl font-bold">Service Level Agreement</h1>
        <p className="text-sm text-ink-muted mt-1">Monthly uptime target: 99.9% for core service.</p>
      </div>

      <div className="card space-y-3 text-sm leading-6 text-ink-muted">
        <p>
          SLA covers dashboard, API endpoints, and subscription lifecycle integrations.
          Planned maintenance windows and customer-side outages are excluded.
        </p>
        <p>
          Service credits: 10% below 99.9%, 25% below 99.0%, and 50% below 95.0% monthly uptime.
        </p>
        <p>
          Claims must be submitted within 30 days after the impacted month with incident evidence.
        </p>
      </div>
    </div>
  );
}
